import { module as Module } from 'modujs'
import LocomotiveScroll from 'locomotive-scroll'

export default class extends Module {
    constructor(m) {
        super(m)

        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual'

            window.scrollTo(0,0)
        }
    }

    init() {
        this.scroll = new LocomotiveScroll({
            lenisOptions: {
                duration: 1,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            },
            modularInstance: this,
        })

        this.scroll.lenisInstance.options.content.addEventListener('wheel', (event) => {
            const paths = event.composedPath();

            paths.find((el) => {
                if(el instanceof HTMLElement && el?.classList.contains('m-add-to-cart-popup-container')) {
                    event.stopPropagation();

                    return;
                }
            })
        });
    }

    /**
     * Scroll to
     *
     * @param {object}
     */
    scrollTo(params) {
        const { target, options } = params

        this.scroll?.scrollTo(target, options)
    }

    stop() {
        this.scroll?.stop()
    }

    start() {
        this.scroll?.start()
    }

    /**
    * Observe new scroll elements
    *
    * @param $newContainer (HTMLElement)
    */
    addScrollElements($newContainer) {
        this.scroll?.addScrollElements($newContainer)
    }

    /**
    * Unobserve scroll elements
    *
    * @param $oldContainer (HTMLElement)
    */
    removeScrollElements($oldContainer) {
        this.scroll?.removeScrollElements($oldContainer)
    }

    destroy() {
        super.destroy()
        // Scroll Instance
        this.scroll?.destroy()
    }
}
